<template>
  <Breadcrumb></Breadcrumb>
  <SaleListingAgreementForm :saleListingAgreement="saleListingAgreement" :title="$gettext('Nouvelle mission de vente')" @submit="onSubmit" @cancel="onCancel" />
</template>

<script setup>
import { useSaleListingAgreementStore } from "@/stores/saleListingAgreement";
import { useRouter } from "vue-router";
import SaleListingAgreementForm from "@/components/sale-listing-agreements/SaleListingAgreementForm.vue";
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";

const router = useRouter();
const saleListingAgreementStore = useSaleListingAgreementStore();
const saleListingAgreement = saleListingAgreementStore.empty;

const onSubmit = (payload, actions) => {
  saleListingAgreementStore.save(payload, (saleListingAgreement) => {
    router.push({ name: "sale-listing-agreement", params: { id: saleListingAgreement.id } });
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const onCancel = () => {
  router.back();
};

</script>
